export const getCategoryIcon = (name: string) => {
  const lowerName = name.toLowerCase();
  
  const matches = (...patterns: string[]) => patterns.some(p => lowerName.includes(p));

  if (matches('икра', 'икры')) return <i className="fi fi-rr-circle-small" style={{ fontSize: '20px', color: '#FF5252' }}></i>;
  if (matches('арахис')) return <i className="fi fi-rr-cookie" style={{ fontSize: '20px', color: '#8D6E63' }}></i>;
  if (matches('фисташк')) return <i className="fi fi-rr-leaf" style={{ fontSize: '20px', color: '#66BB6A' }}></i>;
  if (matches('гренк')) return <i className="fi fi-rr-wheat" style={{ fontSize: '20px', color: '#FFCA28' }}></i>;
  if (matches('кальмар')) return <i className="fi fi-rr-squid" style={{ fontSize: '20px', color: '#AB47BC' }}></i>;
  if (matches('рыб')) return <i className="fi fi-rr-fish" style={{ fontSize: '20px', color: '#42A5F5' }}></i>;
  if (matches('колбас')) return <i className="fi fi-rr-sausage" style={{ fontSize: '20px', color: '#EF5350' }}></i>;
  if (matches('мяс')) return <i className="fi fi-rr-steak" style={{ fontSize: '20px', color: '#E53935' }}></i>;
  if (matches('сыр')) return <i className="fi fi-rr-cheese" style={{ fontSize: '20px', color: '#FDD835' }}></i>;

  return null;
};
